class ModalDialog extends HTMLElement {
  constructor() {
    super();

    document.body.appendChild(this);

    const allSameDialogs = document.querySelectorAll(`#${this.id}`);
    if (allSameDialogs) {
      allSameDialogs.forEach(
        (element, idx) => allSameDialogs[idx + 1] && element.remove()
      );
    }

    this.querySelectorAll('[id^="ModalClose-"]').forEach((button) =>
      button.addEventListener("click", this.hide.bind(this, false))
    );
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(
        this.getAttribute("custom-data-modal")
      );
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);
